import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const Testimonials = () => {
  const testimonials = [
  {
    name: "Fatima Ahmed",
    role: "Food Blogger",
    image: "https://images.unsplash.com/photo-1718048170732-0ef8a77fce9e",
    imageAlt: "Professional portrait of young Muslim woman wearing colorful hijab smiling warmly at camera with natural lighting and blurred background",
    quote: "Finally, authentic Mexican flavors that respect halal requirements! The attention to ingredient sourcing and preparation transparency is remarkable. Taco Street has become my go-to recommendation for anyone seeking genuine street food experience in Bengaluru.",
    rating: 5
  },
  {
    name: "Arjun Krishnan",
    role: "Regular Customer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b5ea51b0-1763293852695.png",
    imageAlt: "Casual portrait of young Indian man with short black hair wearing blue shirt smiling confidently in modern urban setting",
    quote: "The vibe here is unmatched—it genuinely feels like stepping into a Mexican street food scene. The staff's passion for what they do shows in every taco. Plus, knowing they support local farmers makes every bite even better.",
    rating: 5
  },
  {
    name: "Priya Sharma",
    role: "Corporate Professional",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ecb4aca8-1763296537332.png",
    imageAlt: "Professional headshot of Indian businesswoman with long dark hair wearing formal blazer smiling professionally against neutral background",
    quote: "As someone who travels frequently, I can confidently say Taco Street's quality rivals the best taquerias I've tried globally. The halal certification gives me peace of mind, and the fresh ingredients are evident in every dish.",
    rating: 5
  },
  {
    name: "Mohammed Rizwan",
    role: "Food Enthusiast",
    image: "https://images.unsplash.com/photo-1656919156718-fd861ecc2873",
    imageAlt: "Friendly portrait of young Muslim man with beard wearing casual white shirt smiling warmly in outdoor setting with natural lighting",
    quote: "Taco Street bridges cultures beautifully. The team's commitment to authentic Mexican recipes while maintaining halal standards is impressive. It's become our family's favorite weekend destination.",
    rating: 5
  }];


  return (
    <section className="py-20 bg-gradient-to-br from-accent/5 to-primary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            What Our <span className="text-primary">Community Says</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Real stories from real food lovers
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="bg-background p-8 rounded-xl border border-border hover:border-primary transition-all duration-300 hover:shadow-lg animate-slide-up"
            style={{ animationDelay: `${index * 100}ms` }}>

              <div className="flex items-start gap-4 mb-6">
                <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                  src={testimonial?.image}
                  alt={testimonial?.imageAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-semibold text-foreground">{testimonial?.name}</h4>
                  <p className="text-sm text-muted-foreground mb-2">{testimonial?.role}</p>
                  <div className="flex gap-1">
                    {[...Array(testimonial?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={16} color="var(--color-brand-amber)" strokeWidth={0} fill="var(--color-brand-amber)" />
                  )}
                  </div>
                </div>
              </div>
              <p className="text-muted-foreground leading-relaxed italic">
                &ldquo;{testimonial?.quote}&rdquo;
              </p>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-6 py-3 rounded-full">
            <Icon name="Users" size={20} color="var(--color-primary)" />
            <span className="text-foreground font-semibold">Join 100,000+ satisfied customers</span>
          </div>
        </div>
      </div>
    </section>);

};

export default Testimonials;